import { OrderHistoryView } from "./order-history-view";
import { useOrderHistory } from "./use-order-history";

export const OrderHistory = () => {
  const logic = useOrderHistory();
  return <OrderHistoryView {...logic} />;
};
